import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PromptSetApiService } from '../../shared/api.service';
import { lastValueFrom } from 'rxjs';

export interface DeleteAllPromptsDialogData {
    promptSetName: string;
    prompts: { prompt_identifier?: string; promptIdentifier?: string; name?: string }[];
}

@Component({
    selector: 'delete-all-prompts-dialog',
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, MatProgressSpinnerModule, MatFormFieldModule, MatInputModule, CommonModule, FormsModule],
    templateUrl: './delete-all-prompts-dialog.component.html'
})
export class DeleteAllPromptsDialogComponent {

    isSubmitting = false;
    deletedCount = 0;
    errorCount = 0;
    confirmText = '';

    constructor(
        public dialogRef: MatDialogRef<DeleteAllPromptsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DeleteAllPromptsDialogData,
        private promptApiService: PromptSetApiService
    ) {}

    get totalPrompts(): number {
        return this.data.prompts?.length || 0;
    }

    get isDeleteConfirmed(): boolean {
        return this.confirmText.trim().toLowerCase() === 'delete';
    }

    async deleteAllPrompts(): Promise<void> {
        this.isSubmitting = true;
        this.deletedCount = 0;
        this.errorCount = 0;

        for (const prompt of this.data.prompts) {
            const promptId = prompt.prompt_identifier || prompt.promptIdentifier;
            if (!promptId) {
                this.errorCount++;
                continue;
            }

            try {
                await lastValueFrom(
                    this.promptApiService.deletePrompt({ promptIdentifier: promptId })
                );
                this.deletedCount++;
            } catch (error) {
                console.error(`Error deleting prompt ${promptId}:`, error);
                this.errorCount++;
            }
        }

        this.isSubmitting = false;
        this.dialogRef.close({ deletedCount: this.deletedCount, errorCount: this.errorCount });
    }

    cancel(): void {
        this.dialogRef.close(false);
    }
}
